import store from "@/store";

export default {
  requireLogged(to, from, next) {
    if (process.env.IS_LOGIN_OFF === "true") {
      return next();
    } else if (to?.query?.token) {
      store.dispatch("AuthorizationStore/setToken", to.query.token);
      return next({ path: to.path });
    } else if (store.getters["AuthorizationStore/getAuthState"]) {
      return next();
    } else {
      return store.dispatch("AuthorizationStore/getToken");
    }
  },
  redirectFromNotFound(to, from, next) {
    if (store.getters["AuthorizationStore/getAuthState"]) {
      return next({ name: "Autopricing" });
    } else {
      return store.dispatch("AuthorizationStore/getToken");
    }
  },
  isAdmin(to, from, next) {
    if (to?.query?.token) {
      store.dispatch("AuthorizationStore/setToken", to.query.token);
      return next({ path: to.path });
    } else if (store.getters["AuthorizationStore/getAuthState"]) {
      if (store.getters["AuthorizationStore/getUserIsAdmin"]) {
        return next();
      } else {
        return next({ name: "Home" });
      }
    } else {
      return store.dispatch("AuthorizationStore/getToken");
    }
  },
  isEditor(to, from, next) {
    if (to?.query?.token) {
      store.dispatch("AuthorizationStore/setToken", to.query.token);
      return next({ path: to.path });
    } else if (store.getters["AuthorizationStore/getAuthState"]) {
      if (store.getters["AuthorizationStore/getUserIsEditor"]) {
        return next();
      } else {
        return next({ name: "Home" });
      }
    } else {
      return store.dispatch("AuthorizationStore/getToken");
    }
  }
};
